import api from '@/client/core/api'

// Instagram インスタントウィン シナリオ: ステップ別コンテナ取得 API

export interface InstagramScenarioContainerNodeOption {
  id: number
  type: string
  isFinally: boolean
  parentIds?: number[]
  text?: string | null
}

export interface InstagramScenarioContainerNode {
  id: number
  type: string
  isFinally: boolean
  parentIds?: number[]
  text?: string | null
  selectOption?: InstagramScenarioContainerNodeOption[]
  media?: {
    media_id: number
    url: string
    fileType: string
    mediaOriginName?: string | null
  }
  card?: {
    title: string
    subtitle: string
    url: string
    mediaId: number
    buttons: Array<{ id?: number; name: string; url: string }>
    cardUrl?: string
    mediaOriginName?: string | null
  }
}

export interface InstagramScenarioContainerResponseData {
  containerId: number
  stepOrder: number
  type: string
  nodes: InstagramScenarioContainerNode[]
}

export async function getInstagramScenarioContainer(
  prizeId: number,
  stepOrder: 1 | 2 | 3 | 4
): Promise<InstagramScenarioContainerResponseData> {
  const axiosResult = await api.get<{ data: InstagramScenarioContainerResponseData }>(
    '/instagram_instantwin_node_container',
    { params: { prizeId, stepOrder } }
  )
  return axiosResult.data
}
